import { FormattedMessage } from "@metsooutotec/modes-react-components";
import { FC } from "react";

export const NotFound: FC<{ id?: string }> = ({ id }) => {
    const compId: string = id ?? "Id.NotFound";

    return <FormattedMessage id={compId} defaultValue={compId} />;
};